// Distribute chairs around a table based on shape
const computeAutoPositions = (table, chairCount) => {
  if (chairCount === 0) return [];

  const cx = table.x + table.width / 2;
  const cy = table.y + table.height / 2;

  if (table.shape === 'circle') {
    const rx = table.width / 2 + 3;
    const ry = table.height / 2 + 3.5;
    return Array.from({ length: chairCount }, (_, i) => {
      const angle = (2 * Math.PI * i) / chairCount - Math.PI / 2;
      return {
        x: cx + rx * Math.cos(angle) - 1.5,
        y: cy + ry * Math.sin(angle) - 2
      };
    });
  }

  const pad = 3;
  const chairW = 3;
  const chairH = 4;
  const left = table.x - pad;
  const right = table.x + table.width + pad - chairW;
  const top = table.y - pad - chairH / 2;
  const bottom = table.y + table.height + pad - chairH / 2;

  const perimeter = [];
  const sides = [
    { axis: 'top', from: table.x, to: table.x + table.width, fixed: top, horizontal: true },
    { axis: 'right', from: table.y, to: table.y + table.height, fixed: right, horizontal: false },
    { axis: 'bottom', from: table.x + table.width, to: table.x, fixed: bottom, horizontal: true },
    { axis: 'left', from: table.y + table.height, to: table.y, fixed: left, horizontal: false },
  ];

  const totalLen = 2 * (table.width + table.height);
  const sideLengths = [table.width, table.height, table.width, table.height];
  let remaining = chairCount;
  const perSide = sideLengths.map((len, i) => {
    if (i === 3) return remaining;
    const n = Math.round((len / totalLen) * chairCount);
    remaining -= n;
    return n;
  });

  sides.forEach((side, sIdx) => {
    const count = perSide[sIdx];
    if (count <= 0) return;
    for (let i = 0; i < count; i++) {
      const t = count === 1 ? 0.5 : i / (count - 1);
      if (side.horizontal) {
        const pos = side.from + (side.to - side.from) * t - chairW / 2;
        perimeter.push({ x: pos, y: side.fixed });
      } else {
        const pos = side.from + (side.to - side.from) * t - chairH / 2;
        perimeter.push({ x: side.fixed, y: pos });
      }
    }
  });

  return perimeter.slice(0, chairCount);
};

// Legacy: returns just auto positions (no overrides).
export const getChairPositions = (table, chairCount) =>
  computeAutoPositions(table, chairCount);

// Returns positions for chairs, honouring per-chair posX/posY overrides.
// Pass the actual chair list (with posX/posY fields), not just the count.
export const getChairPositionsWithOverrides = (table, chairs) => {
  const auto = computeAutoPositions(table, chairs.length);
  return chairs.map((c, idx) => {
    const hasOverride = c.posX != null && c.posY != null;
    return hasOverride ? { x: c.posX, y: c.posY } : (auto[idx] || { x: table.x, y: table.y });
  });
};
